
const SponsorshipStatus = {
    NO_SPONSOR: 'NO_SPONSOR',
    IN_SCHEDULED: 'IN_SCHEDULED',
    IN_PROGRESS: 'IN_PROGRESS',
    ALL_COMPLETE: 'ALL_COMPLETE',
};

export default SponsorshipStatus